import { render, staticRenderFns } from "./dialog.auth-detail.vue?vue&type=template&id=27b8600c&"
import script from "./dialog.auth-detail.vue?vue&type=script&lang=js&"
export * from "./dialog.auth-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports